import '../stylesheets/full-page-marquee.css';

const loopArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const FullPageMarquee = ({ className, LoopComponent }) => (
  <div className={`marquee-container-outer ${className ? className : null}`}>
    <div className={`marquee-container-inner`}>
      {
        loopArray.map((n) => {
          return (
            <div className="marquee-animation" key={`marquee-${n}`}>
              <div>
                <LoopComponent />
              </div>
            </div>
          );
        })
      }
    </div>
  </div>
);

export default FullPageMarquee;
